import Menu from '@mui/material/Menu'
import Button from '@mui/material/Button'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { useState } from 'react'
import MenuItem from '@mui/material/MenuItem'
import Fade from '@mui/material/Fade'

export const NavMenu = ({
  menuTextOrComponent = 'menu text',
  menuItems = [],
  showCaret = true,
  children,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <Button
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={showCaret ? <KeyboardArrowDownIcon /> : null}
        disableFocusRipple
        disableRipple
        size="large"
        sx={[
          {
            color: '#344767',
            textTransform: 'capitalize',
          },
          {
            '&:hover': {
              color: '#344767',
              transform: 'none',
            },
          },
          {
            '&:focus': {
              color: '#344767 !important',
            },
          },
        ]}
      >
        {menuTextOrComponent}
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {children
          ? children
          : menuItems.map(({ item, clickHandler, key }, _i) => {
              return (
                <MenuItem
                  sx={{ '&:empty': { display: 'none' } }}
                  key={key}
                  onClick={(event) => {
                    clickHandler && clickHandler(event)
                    handleClose()
                  }}
                >
                  {item}
                </MenuItem>
              )
            })}
      </Menu>
    </div>
  )
}
